import Visibility from 'lib/browser/visibility';
import { fetchTreatments, emitSplitTreatments } from 'store/split/splitActions';
import { getTreatments } from 'store/split/splitSelectors';
import { SPLIT_BROWSER_REFRESH_RATE_SECS } from 'config';

export const initializeSplit = (store) => {
  const treatments = getTreatments(store.getState());
  store.dispatch(emitSplitTreatments(treatments));

  Visibility.every(SPLIT_BROWSER_REFRESH_RATE_SECS * 1000, () => {
    store.dispatch(fetchTreatments());
  });
};
